import apiFetch from '@wordpress/api-fetch';
/**
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

const testingModeEnabled = false; // This enables showing all pathways when logged-in (slows browser!)

window.addEventListener( 'DOMContentLoaded', async ( event ) => {
	async function fetchStoreData( section ) {
		const decisionMainEl = document.querySelector( '.decisionSupportMain' );
		let caching = true;
		let clear = '0';
		let decisionData;

		const url1 = new URL( window.location );
		clear = url1.searchParams.get( 'clearcache' );
		let clearcacheN = 0;

		if ( clear === '1' ) {
			clearcacheN = '1';
		}

		if ( decisionMainEl ) {
			const cachingInd = decisionMainEl.dataset.caching;
			if ( cachingInd === '2' ) {
				caching = false;
			}
		}

		let c = 0;
		const url = new URL( window.location );
		c = url.searchParams.get( 'clearcache' );
		const apiPath = 'decision-support/v1/sheetfetch';
		apiFetch( {
			path: apiPath,
			method: 'POST',
			data: { clearcache: clearcacheN },
		} ).then( ( sheetData ) => {
			/* console.log(data);*/
			/* const sheetData = JSON.parse(data);*/

			const questions = sheetData.questions.filter( ( word ) =>
				/^[0-9]/.test( word[ 0 ] )
			);
			questions.unshift( [ '0', 'Start' ] );

			const decisionData = new Object();
			decisionData.questions = questions;
			decisionData.sections = sheetData.questions.filter( ( word ) =>
				word[ 0 ].startsWith( 'Q' )
			);
			decisionData.pathways = sheetData.pathways;
			decisionData.infeasibleQs = sheetData.infeasibleQs;
			decisionData.dietPaths = sheetData.dietPaths;
			decisionData.foodPaths = sheetData.foodPaths;
			decisionData.dietKits = sheetData.dietresources;
			decisionData.foodKits = sheetData.foodresources;
			const curTimestampData = Math.floor( Date.now() / 1000 );
			window.localStorage.setItem(
				'decision_data_date',
				curTimestampData
			);
			window.localStorage.setItem(
				'decision_data',
				JSON.stringify( decisionData )
			);
			/* Only continue if not 'initial' */
			if ( section !== 'initial' ) {
				displayQuestions( decisionData, section );
			}
		} );
	}

	runNutritionModal( 'feedbackModal' );

	/* Pre-store the data above */
	const decisionData = await fetchStoreData( 'initial' );

	const url2 = new URL( window.location );
	const checkpathways = url2.searchParams.get( 'checkpathways' );
	if ( checkpathways === '1' ) {
		const detailsDiv = document.querySelector( '.moreInfoDetails' );
		if ( detailsDiv ) {
			detailsDiv.open = true;
			checkInfeasiblePathways( decisionData );
		}
	}

	const decisionDietAdmin = document.querySelector( '#decisionDietPathways' );
	const decisionFoodAdmin = document.querySelector( '#decisionFoodPathways' );
	if ( testingModeEnabled && decisionDietAdmin && decisionFoodAdmin ) {
		showDietDecisionTable( decisionData, decisionDietAdmin );
		showFoodDecisionTable( decisionData, decisionFoodAdmin );
	}

	const initialContainer = document.querySelector( '.mainDecisionSupport' );
	if ( initialContainer ) {
		const structure = createCustomStructure(
			'section',
			{ class: [ 'decisionSection' ] },
			{},
			[ [ 'section', { class: [ 'decisionStage' ] }, {} ] ]
		);
		initialContainer.append( structure );
		const initialBtns = document.querySelectorAll( '.decisionNav' );
		const toolDispSections =
			document.querySelectorAll( '.toolDispSection' );

		initialBtns.forEach( async ( initBtn ) => {
			initBtn.addEventListener( 'click', async ( evt ) => {
				const btn = evt.target;
				//console.log( btn );
				if ( btn.classList.contains( 'pathwayStatus' ) ) {
					return;
				}

				initialBtns.forEach( async ( initBtn2 ) => {
					initBtn2.classList.remove( 'active' );
				} );

				btn.classList.add( 'active' );
				btn.classList.add( 'started' );
				const section = evt.target.dataset.section;

				const startSection = document.querySelector(
					'.food_diet_decision'
				);
				if ( startSection ) {
					startSection.classList.remove( 'starting' );
					startSection.classList.add( 'started' );
					startSection.classList.remove( 'diet', 'food' );
					startSection.classList.add( section );
				}
				const containerSection = document.querySelector(
					'.decisionSupportMain'
				);
				if ( containerSection ) {
					containerSection.classList.remove( 'starting' );
					containerSection.classList.remove( 'initial' );
					containerSection.classList.remove( 'started' );
				}
				/* Close all Tool Display Sections */
				toolDispSections.forEach( ( toolDisp ) =>
					toolDisp.classList.add( 'hidden' )
				);

				const decisionData = await fetchStoreData( section );

				if ( decisionData ) {
					let querySel = '.qaSection.dietContainer';
					if ( section === 'food' ) {
						querySel = '.qaSection.foodContainer';
					}
					const curSection = document.querySelector( querySel );
					//console.log('current section ' + section)
					// console.log(curSection)
					if ( curSection ) {
						curSection.classList.remove( 'hidden' );
					}
					initialQuestions( decisionData, section );
				}
			} );
			/* initBtn.addEventListener('mouseover', async (evt) => {

               const btn=evt.target;
               const section=evt.target.dataset.opensection;
                //console.log(section)
                const showOpen = document.querySelector('.' + section)
                if (showOpen) {showOpen.classList.add('showIntro'); }



            })*/
			/*initBtn.addEventListener('mouseout', async (evt) => {

               const btn=evt.target;
               const section=evt.target.dataset.opensection;
                const showOpen = document.querySelector('.' + section)
                if (showOpen) {showOpen.classList.remove('showIntro'); }


            })*/
		} );
		const startBtns = document.querySelectorAll( '.introBtn' );

		// These are the yellow start buttons
		startBtns.forEach( async ( startBtn ) => {
			startBtn.addEventListener( 'click', async ( evt ) => {
				initialBtns.forEach( async ( initBtn2 ) => {
					initBtn2.classList.remove( 'active' );
				} );

				const btn = evt.target;
				const section = evt.target.dataset.section;

				const parentBtn = document.querySelector(
					'.' + section + 'Nav'
				);
				if ( parentBtn ) {
					parentBtn.classList.add( 'active' );
					parentBtn.classList.add( 'started' );
					if ( section === 'food' ) {
						if ( parentBtn.childNodes[ 0 ] ) {
							parentBtn.childNodes[ 0 ].textContent =
								'Food Environment questions';
						}
					} else if ( section === 'diet' ) {
						if ( parentBtn.childNodes[ 0 ] ) {
							parentBtn.childNodes[ 0 ].textContent =
								'Diet questions';
						}
					}
				}

				const startSection = document.querySelector(
					'.food_diet_decision'
				);
				if ( startSection ) {
					startSection.classList.remove( 'starting' );
					startSection.classList.add( 'started' );
					startSection.classList.remove( 'diet', 'food' );
					startSection.classList.add( section );
				}
				/* Close all Tool Display Sectoins */
				toolDispSections.forEach( ( toolDisp ) =>
					toolDisp.classList.add( 'hidden' )
				);
				const decisionData = await fetchStoreData( section );
				if ( decisionData ) {
					let querySel = '.qaSection.dietContainer';
					if ( section === 'food' ) {
						querySel = '.qaSection.foodContainer';
					}
					const curSection = document.querySelector( querySel );
					//console.log('current section ' + section)
					// console.log(curSection)
					if ( curSection ) {
						curSection.classList.remove( 'hidden' );
					}
					initialQuestions( decisionData, section );
				}
			} );
		} );
	}

	function displayQuestions( decisionData, section ) {
		let querySel = '.qaSection.dietContainer';
		if ( section === 'food' ) {
			querySel = '.qaSection.foodContainer';
		}
		const curSection = document.querySelector( querySel );
		if ( curSection ) {
			curSection.classList.remove( 'hidden' );
		}
		initialQuestions( decisionData, section );
	}

	function initialQuestions( decisionData, section ) {
		// console.log(decisionData)
		const displayQs = document.querySelector( '.recommendReached' );
		if ( displayQs ) {
			displayQs.classList.remove( 'recommendReached' );
		}
		let startLevel = 1;
		let initialQindex = 0;
		if ( section === 'food' ) {
			startLevel = 8;
			initialQindex = 26;
		}
		const existingSection = document.querySelector(
			'.decisionQA.question' + startLevel
		);
		if ( existingSection ) {
			createPathwayQuestions( startLevel, initialQindex, decisionData );
		} else {
			createSection( startLevel, decisionData.sections );
			createPathwayQuestions( startLevel, initialQindex, decisionData );
		}
		/* For switching between kits */
		const decisionBtns = document.querySelectorAll( '.recommendBtn' );
		// console.log(decisionBtns.length)
		decisionBtns.forEach( function ( decisionBtn ) {
			decisionBtn.addEventListener( 'click', function ( evt ) {
				const toolSections = document.querySelectorAll(
					'.nutitionRecSection'
				);
				toolSections.forEach( ( toolSection ) =>
					toolSection.classList.add( 'hidden' )
				);
				const displaySection = evt.target;
				const displayCategory = displaySection.dataset.tooldisplay;
				checkValidity( decisionData, displayCategory );
			} );
		} );


	/* const dietPathwayStat = createCustomElement('div', {"class":['pathwayStatus', 'dietPathwayStatus']}, {'title': 'Indicator for valid diet choice pathway'}) */
	const dietPathwayStat = document.querySelector( '.dietPathwayStatus' );
	/* const foodPathwayStat = createCustomElement('div', {"class":['pathwayStatus', 'foodPathwayStatus']}, {'title': 'Indicator for valid food environment choice pathway'})*/
	const foodPathwayStat = document.querySelector( '.foodPathwayStatus' );

	/* const showPathwayStat = createCustomElement('div', {"class":['pathwayStatus', 'choicesSummary','pathwayShowHide']}, {'title': 'Print your choices, and recommended toolkits'})*/

	const showPathwayStat = document.querySelector( '.pathwayShowHide' );
	if ( showPathwayStat ) {
		showPathwayStat.addEventListener( 'click', function ( evt ) {
			const invalids = document.querySelectorAll( '.invalidCombination' );
			invalids.forEach( function ( inval ) {
				if ( inval.classList.contains( 'showInvalidCombo' ) ) {
					inval.classList.remove( 'showInvalidCombo' );
				} else {
					inval.classList.add( 'showInvalidCombo' );
				}
			} );
			displayResultsDialog( decisionData );
		} );
	}


}



	/*
        const mainSection = document.querySelector('.wp-site-blocks');*/
	/*  if (mainSection) {*/

	/* mainSection.append(dietPathwayStat, foodPathwayStat, showPathwayStat);*/
	/* mainSection.append(showPathwayStat);*/
	/* }*/

	/***************************************************************************
	 * Utility functions to save Spreadsheet JSON data to uploads folder
	 ***************************************************************************/
	const saveJSONelm = document.querySelector( '.saveJson' );
	if ( saveJSONelm ) {
		saveJSONelm.addEventListener( 'click', function ( evt ) {
			evt.preventDefault();
			const apiPath = '/decision-support/v1/savejson';
			getJSONData( apiPath );
		} );

		async function getJSONData( jsonSource ) {
			apiFetch( {
				path: jsonSource,
				method: 'GET',
			} ) //data: { "path" : path, "groupid": groupid } ,
				.then( ( result ) => {

					if (result.success == false) {
						const newError = createCustomElement(
							'p',
							{},
							{},
							result.message 
						);
						saveJSONelm.after( newError );
						return;

					}
					/* console.log(item);
                    const decoded = JSON.parse(item);*/
					
					let additionalMsg = "The PDF files were saved to the kits/ folder in the plugin directory";
					if (!result.kits_writable) {
						additionalMsg = result.kits_error;
					}

					let mergeMsg = "";
					if (result.merge_kits_result && result.merge_kits_result.length > 0) {
						if (result.merge_kits_result[0].success) {
							mergeMsg = "The kits were also merged for combined PDF download";
						} else {
							mergeMsg = "There was a problem merging the kits for combined PDFs: " + result.merge_kits_result[0].message;
						}
					}

					// Build failure report from kits_files_status
					let failureMsg = "";
					if (result.kits_files_status && result.kits_files_status.length > 0) {
						const failures = result.kits_files_status.filter( f => !f.success );
						if (failures.length > 0) {
							failureMsg = "⚠ " + failures.length + " PDF file(s) could not be saved:\n" +
								failures.map( f => "• " + f.file + ": " + f.reason ).join("\n");
						}
					}

					const newElm = createCustomElement(
						'p',
						{},
						{},
						'Saved file to : ' + result.url
					);
					const newElm2 = createCustomElement(
						'p',
						{},
						{},
						additionalMsg
					);
					const newElm3 = createCustomElement(
						'p',
						{},
						{},
						mergeMsg
					);

					const elementsToInsert = [ newElm, newElm2, newElm3 ];

					if (failureMsg) {
						const newElmFailures = createCustomElement(
							'pre',
							{ style: 'color: #cc0000; background: #fff3f3; padding: 8px; border-left: 3px solid #cc0000; white-space: pre-wrap;' },
							{},
							failureMsg
						);
						elementsToInsert.push( newElmFailures );
					}

					saveJSONelm.after( ...elementsToInsert );
				} );
		}
	}
	/*** End Utility functions to save Spreadsheet JSON data to uploads folder  ********/
} );

function displayResultsDialog( decisionData = null ) {
	const recommendedKitD = document.querySelector( '.currentDietResAdmin' );
	const kitURLD = recommendedKitD.dataset.kitpdf;
	const kitDescD = recommendedKitD.dataset.kitname;
	const kitCodeD = recommendedKitD.dataset.kitcode;
	const kitpathdiet = recommendedKitD.dataset.kitpath;
	const recommendedKitF = document.querySelector( '.currentFoodResAdmin' );
	const kitURLF = recommendedKitF.dataset.kitpdf;
	const kitDescF = recommendedKitF.dataset.kitname;
	const kitCodeF = recommendedKitF.dataset.kitcode;
	const kitpathfood = recommendedKitF.dataset.kitpath;
	const kitResourceU = decisionData.foodKits.find(
		( el ) => el[ 0 ] === 'urban_considerations'
	);
	const kitURLU = kitResourceU[ 2 ];
	const theDialog = document.querySelector( 'dialog.decisionModal' );
	if ( theDialog ) {
		theDialog.showModal();
		const dietSection = document.querySelector( '.dietContainer' );
		let anyAnswers = false;
		const theDialogContents = theDialog.querySelector(
			'.decisionModalContents'
		);
		if ( theDialogContents ) {
			empty( theDialogContents );
		}

		if ( theDialogContents ) {
			if ( kitURLD !== '' || kitURLF !== '' ) {
				const downloadsSectionH = createCustomElement(
					'h3',
					{ class: [ 'ansDnld' ] },
					{},
					'Download Results'
				);
				theDialogContents.append( downloadsSectionH );
			}

			if ( kitURLD !== '' ) {
				const downloadsDivD = createCustomElement(
					'div',
					{ class: [ 'downloadKitP' ] },
					{}
				);
				const downloadsHD = createCustomElement(
					'h4',
					{ class: [ 'downloadKitS' ] },
					{},
					kitDescD + ' '
				);
				const downloadsLinkWrapD = createCustomElement(
					'p',
					{ class: [ 'downloadKitWrap' ] },
					{}
				);
				const downloadLinkD = createCustomElement(
					'a',
					{ class: [ 'nutritionDldBtn', 'downloadLink' ] },
					{ href: kitURLD, target: '_blank' },
					'Download PDF'
				);
				downloadsLinkWrapD.append( downloadLinkD );
				downloadsDivD.append( downloadsHD, downloadsLinkWrapD );
				theDialogContents.append( downloadsDivD );
			} else {
				const downloadsDivD = createCustomElement(
					'div',
					{ class: [ 'downloadKitP' ] },
					{}
				);
				const downloadsHD = createCustomElement(
					'h4',
					{ class: [ 'downloadKitS' ] },
					{},
					'Dietary Assessment'
				);
				const downloadsLinkWrapD = createCustomElement(
					'p',
					{ class: [ 'downloadKitWrap' ] },
					{},
					'Please answer the Diet questions'
				);
				downloadsDivD.append( downloadsHD, downloadsLinkWrapD );
				theDialogContents.append( downloadsDivD );
			}

			if ( kitURLF !== '' ) {
				
				const downloadsDivF = createCustomElement(
					'div',
					{ class: [ 'downloadKitP' ] },
					{}
				);
				const downloadsHF = createCustomElement(
					'h4',
					{ class: [ 'downloadKitS' ] },
					{},
					kitDescF + ' '
				);
				const downloadsLinkWrapF = createCustomElement(
					'p',
					{ class: [ 'downloadKitWrap' ] },
					{}
				);
				const downloadLinkF = createCustomElement(
					'a',
					{ class: [ 'nutritionDldBtn', 'downloadLink' ] },
					{ href: kitURLF, target: '_blank' },
					'Download PDF'
				);
				downloadsLinkWrapF.append( downloadLinkF );
				downloadsDivF.append( downloadsHF, downloadsLinkWrapF );
				theDialogContents.append( downloadsDivF );
			} else {
				const downloadsDivF = createCustomElement(
					'div',
					{ class: [ 'downloadKitP' ] },
					{}
				);
				const downloadsHF = createCustomElement(
					'h4',
					{ class: [ 'downloadKitS' ] },
					{},
					'Food Environment Assessment'
				);
				const downloadsLinkWrapF = createCustomElement(
					'p',
					{ class: [ 'downloadKitWrap' ] },
					{},
					'Please complete the Food Environment section'
				);
				downloadsDivF.append( downloadsHF, downloadsLinkWrapF );
				theDialogContents.append( downloadsDivF );
			}

			const downloadsDivU = createCustomElement(
				'div',
				{ class: [ 'downloadKitP' ] },
				{}
			);
			const downloadsHU = createCustomElement(
				'h4',
				{ class: [ 'downloadKitS' ] },
				{},
				'Urban Considerations'
			);
			const downloadsLinkWrapU = createCustomElement(
				'p',
				{ class: [ 'downloadKitWrap' ] },
				{}
			);
			const downloadLinkU = createCustomElement(
				'a',
				{ class: [ 'nutritionDldBtn', 'downloadLink' ] },
				{ href: kitURLU, target: '_blank' },
				'Download PDF'
			);
			downloadsLinkWrapU.append( downloadLinkU );
			downloadsDivU.append( downloadsHU, downloadsLinkWrapU );
			theDialogContents.append( downloadsDivU );

			/* Combined files section - files are prepared via a script */
			/* note due to an anomaly, the diet part uses the path, whereas the food section uses the code */
			let dietPart;
			let foodPart;
			let combinedText;
			let combined_file;

			if ( ! kitpathdiet ) {
				foodPart = kitCodeF.toLowerCase();
				combined_file =
					'/wp-content/plugins/decision-support/kits/' +
					foodPart +
					'_urban.pdf';
				combinedText =
					'Download Food Environment and Urban considerations results combined';
			} else if ( ! kitpathfood ) {
				dietPart = replaceFoodPath( kitpathdiet );

				//console.log( dietPart );
				combined_file =
					'/wp-content/plugins/decision-support/kits/' +
					dietPart +
					'_urban.pdf';
				combinedText =
					'Download Diet, and Urban considerations results combined';
			} else {
				dietPart = replaceFoodPath( kitpathdiet );
				foodPart = kitCodeF.toLowerCase();
				combinedText =
					'Download Diet, Food Environment, and Urban considerations results combined';
				combined_file =
					'/wp-content/plugins/decision-support/kits/' +
					dietPart +
					'_' +
					foodPart +
					'_urban.pdf';
			}

			const downloadsDivCombined = createCustomElement(
				'div',
				{ class: [ 'downloadKitP', 'downloadKitCombined' ] },
				{}
			);
			const downloadsHCombined = createCustomElement(
				'h4',
				{ class: [ 'downloadKitS' ] },
				{},
				'Download combined results'
			);
			const downloadsLinkWrapCombined = createCustomElement(
				'p',
				{ class: [ 'downloadKitWrap' ] },
				{}
			);
			const downloadLinkCombined = createCustomElement(
				'a',
				{ class: [ 'nutritionDldBtn', 'downloadLink' ] },
				{ href: combined_file, target: '_blank' },
				'Download combined PDF'
			);
			downloadsLinkWrapCombined.append( downloadLinkCombined );
			downloadsDivCombined.append(
				downloadsHCombined,
				downloadsLinkWrapCombined
			);
			theDialogContents.append( downloadsDivCombined );
		}

		if ( dietSection && theDialogContents ) {
			const sectionDiet = createCustomElement(
				'h3',
				{ class: [ 'ansEnviro' ] },
				{},
				'Your Diet answers'
			);

			const answeredQuestions =
				dietSection.querySelectorAll( '.questionOptions' );

			const sectionDiets = createCustomElement( 'div', {
				class: [ 'answersDiet' ],
			} );
			let someAnswered = false;
			answeredQuestions.forEach( function ( dietQuestion ) {
				const dietQTitleEl = dietQuestion.querySelector( '.decisionQ' );
				if ( dietQTitleEl ) {
					const questionText = dietQTitleEl.textContent;
					const questionRecord = createCustomElement(
						'h4',
						{ class: [ 'ansRecord' ] },
						{},
						questionText
					);
					sectionDiets.append( questionRecord );
				}
				const answer = dietQuestion.querySelector( '.sectionChoice' );
				if ( answer ) {
					const answerText = answer.childNodes[ 0 ].textContent;
					const answerRecord = createCustomElement(
						'p',
						{ class: [ 'ansRecord' ] },
						{},
						answerText
					);
					sectionDiets.append( answerRecord );
					anyAnswers = true;
					someAnswered = true;
				} else {
					const answerRecord = createCustomElement(
						'p',
						{ class: [ 'ansRecord' ] },
						{},
						'Question not answered yet'
					);
					sectionDiets.append( answerRecord );
				}
			} );
			if ( someAnswered ) {
				theDialogContents.append( sectionDiet, sectionDiets );
			}

			/*const recommendedKit = document.querySelector('.currentDietResAdmin');
            if (recommendedKit) {
                const recomendedKitData = recommendedKit.dataset.kitname;
                if (recomendedKitData !== "" && recomendedKitData != false) {
                    const reommendedWrap = createCustomElement('div', { 'class': ['recommendedDiet', 'recommendedWrap'] });
                    const recommendedDietH = createCustomElement('h3', { "class": ['ansKit'] }, {}, "Recommended Diet kit")
                    const recommendedDietP = createCustomElement('p', { "class": ['ansKitP'] }, {}, recomendedKitData)
                    reommendedWrap.append(recommendedDietH, recommendedDietP)
                    theDialogContents.append(reommendedWrap)

                }
            }*/
		}

		const foodSection = document.querySelector( '.foodContainer' );
		if ( foodSection ) {
			const sectionFood = createCustomElement(
				'h3',
				{ class: [ 'ansEnviroFood' ] },
				{},
				'Your Food Environment answers'
			);

			const sectionFoods = createCustomElement( 'div', {
				class: [ 'answersDiet' ],
			} );

			const answeredQuestions =
				foodSection.querySelectorAll( '.questionOptions' );
			let someAnswered = false;
			answeredQuestions.forEach( function ( foodQuestion ) {
				const foodQTitleEl = foodQuestion.querySelector( '.decisionQ' );
				if ( foodQTitleEl ) {
					const questionText = foodQTitleEl.textContent;
					const questionRecord = createCustomElement(
						'h4',
						{ class: [ 'ansRecord' ] },
						{},
						questionText
					);
					sectionFoods.append( questionRecord );
				}
				const answer = foodQuestion.querySelector( '.sectionChoice' );
				if ( answer ) {
					const answerText = answer.childNodes[ 0 ].textContent;
					const answerRecord = createCustomElement(
						'p',
						{ class: [ 'ansRecord' ] },
						{},
						answerText
					);
					sectionFoods.append( answerRecord );
					anyAnswers = true;
					someAnswered = true;
				} else {
					const answerRecord = createCustomElement(
						'p',
						{ class: [ 'ansRecord' ] },
						{},
						'Question not answered yet'
					);
					sectionFoods.append( answerRecord );
				}
			} );
			if ( someAnswered ) {
				theDialogContents.append( sectionFood, sectionFoods );
			}

			/*  const recommendedKitF = document.querySelector('.currentFoodResAdmin');
             if (recommendedKitF) {
                 const recomendedKitFData = recommendedKitF.dataset.kitname;
                 if (recomendedKitFData !== "" && recomendedKitFData != false) {
                     const recommendedFoodH = createCustomElement('h3', { "class": ['ansKit'] }, {}, "Recommended Food Environment kit")
                     const recommendedFoodP = createCustomElement('p', { "class": ['ansKitP'] }, {}, recomendedKitFData)
                     const reommendedWrapF = createCustomElement('div', { 'class': ['recommendedFood', 'recommendedWrap'] });
                     reommendedWrapF.append(recommendedFoodH, recommendedFoodP)
                     theDialogContents.append(reommendedWrapF)

                 }
             }*/
		}

		if ( ! anyAnswers ) {
			empty( theDialogContents );
			const section = createCustomElement(
				'h3',
				{ class: [ 'ansEnviro' ] },
				{},
				'No questions answered yet'
			);
			theDialogContents.append( section );
		}
	}
	// DevNote Listner might be added several times
	const theDialogClose = document.querySelector(
		'button.nutritionCloseModal'
	);
	if ( theDialogClose ) {
		theDialogClose.addEventListener( 'click', function ( evt ) {
			const thisis = evt.target;
			const theClosestDialog = thisis.closest( 'dialog' );
			theClosestDialog.close();
		} );
	}
	const theDialogPrint = document.querySelector(
		'button.nutritionPrintModal'
	);
	if ( theDialogPrint ) {
		theDialogPrint.addEventListener( 'click', function ( evt ) {
			const printTarg = evt.target;
			const theControls = document.querySelector( '.dialogCtrls' );
			let divContents;
			const theClosestDialog = printTarg.closest( 'dialog' );
			if ( theControls ) {
				document.body.append( theControls );
				divContents = theClosestDialog.innerHTML;
				theClosestDialog.append( theControls );
			} else {
				divContents = theClosestDialog.innerHTML;
			}
			// document.body.append(theDialogPrint);

			//theClosestDialog.append(theDialogPrint);
			const printWindow = window.open( '', '', 'height=600,width=900' );

			printWindow.document.write(
				'<html><head><title>Nutrition decision and resources tool - choices</title><style></style>'
			);
			printWindow.document.write( '</head><body >' );
			printWindow.document.write( divContents );
			printWindow.document.write( '</body></html>' );
			printWindow.document.close();
			printWindow.print();
		} );
	}
}

/***************************************************************************
 * Create question section
 ***************************************************************************/

function createSection( level, sections ) {
	let decisionSection;

	const dietSection = document.querySelector( '.dietContainer' );
	const foodSection = document.querySelector( '.foodContainer' );
	const decisionRecommendation = document.querySelector(
		'.mainDecisionResult'
	);
	const dietNav = document.querySelector( '.dietNav' );
	const foodNav = document.querySelector( '.foodNav' );
	const decisionNav = document.querySelector( '.recommendationNav' );
	const decisionMain = document.querySelector( '.decisionStage' );

	const explainations = document.querySelectorAll( '.questExplain' );
	explainations.forEach( ( el ) => {
		el.classList.add( 'hidden' );
	} );

	if ( level < 8 ) {
		decisionSection = dietSection;

		dietSection.classList.remove( 'hidden' );
		foodSection.classList.add( 'hidden' );
		decisionRecommendation.classList.add( 'hidden' );
	} else if ( level > 7 && level < 15 ) {
		decisionSection = foodSection;
		foodSection.classList.remove( 'hidden' );
		dietSection.classList.add( 'hidden' );
		decisionRecommendation.classList.add( 'hidden' );

		//foodNav.classList.add('active');
		//foodNav.classList.remove('hidden')
	} else {
		decisionSection = decisionRecommendation;
		//decisionNav.classList.add('active');
	}

	if ( decisionSection ) {
		const existingSection = document.querySelector(
			'.decisionQA.question' + level
		);
		if ( ! existingSection ) {
			level--;
			//empty(decisionSection);   Do not remove
			const qlevel = level + 1;

			//console.log(sections[level])
			//const decisionQ = createCustomElement('div', {class: ['decisionQ', 'question'+qlevel] }, {}, sections[level][1]);
			const questionsOptions = createCustomElement(
				'section',
				{ class: [ 'questionOptions', 'level' + qlevel ] },
				{ 'data-level': qlevel }
			);
			const decisionQAprevious = createCustomStructure(
				'section',
				{ class: [ 'decisionQA', 'question' + qlevel ] },
				{ 'data-level': qlevel },
				[
					[
						'div',
						{ class: [ 'decisionQ' ] },
						{ 'data-level': qlevel },
						sections[ level ][ 1 ],
					],
					[
						'section',
						{ class: [ 'decisionA', 'decisionA' + qlevel ] },
						{ 'data-level': qlevel },
					],
				]
			);
			const decisionQA = createCustomElement(
				'section',
				{ class: [ 'decisionQA', 'question' + qlevel ] },
				{ 'data-level': qlevel }
			);
			const decisionQuest = createCustomElement(
				'div',
				{ class: [ 'decisionQ' ] },
				{ 'data-level': qlevel },
				sections[ level ][ 1 ]
			);
			const decisionNumber = createCustomElement(
				'span',
				{ class: [ 'qndecisionQnum' ] },
				{ 'data-level': qlevel },
				sections[ level ][ 0 ] + '. '
			);
			decisionQuest.prepend( decisionNumber );
			const decisionAns = createCustomElement(
				'section',
				{ class: [ 'decisionA', 'decisionA' + qlevel ] },
				{ 'data-level': qlevel }
			);
			const decisionInfo = createCustomElement(
				'div',
				{ class: [ 'decisionInfo', 'decisionA' + qlevel ] },
				{ 'data-level': qlevel }
			);
			const decisionInfoImg = createCustomElement(
				'img',
				{ class: [ 'decisionInfoImg', 'decisionA' + qlevel ] },
				{
					'data-level': qlevel,
					src: '/wp-content/plugins/decision-support/showinfo.svg',
				}
			);
			decisionInfo.append( decisionInfoImg );

			const questionExplaination = createCustomElement(
				'div',
				{
					class: [
						'questExplain',
						'hidden',
						'questExplain' + qlevel,
					],
				},
				{ 'data-level': qlevel },
				sections[ level ][ 3 ]
			);
			decisionQA.append( decisionQuest, decisionAns, decisionInfo );
			const currentExplain = document.querySelector(
				'.questionExplaination' + qlevel
			);

			if ( ! currentExplain ) {
				const explainClose = createCustomElement(
					'img',
					{ class: [ 'closeInfoImg', 'decisionA' + qlevel ] },
					{
						'data-level': qlevel,
						src: '/wp-content/plugins/decision-support/close.svg',
					}
				);
				questionExplaination.append( explainClose );
				explainClose.addEventListener( 'click', function ( e ) {
					e.stopPropagation();
					const clickedImg = e.target;
					const parentExp = clickedImg.closest( '.questExplain' );
					if ( parentExp ) {
						parentExp.classList.add( 'hidden' );
					}
				} );
				decisionQA.append( questionExplaination );
			}

			/* const decisionExplainationSection = document.querySelector('.questionExplainationSection');
            if (decisionExplainationSection) {
                decisionExplainationSection.textContent = sections[level][3];
                decisionExplainationSection.classList.remove('hidden');

            } */

			decisionQA.addEventListener( 'click', function ( e ) {
				const clickedQ = e.target;
				const clickedlevel = clickedQ.dataset.level;
				const currentQuestion = document.querySelector(
					'.questionSection.level' + clickedlevel
				);

				if ( currentQuestion ) {
					if ( currentQuestion.classList.contains( 'hidden' ) ) {
						closeQuestions();
						currentQuestion.classList.remove( 'hidden' );
						toggleParentActive( currentQuestion );
					} else {
						currentQuestion.classList.add( 'hidden' );
						toggleParentActive( currentQuestion );
						const qExplain = document.querySelector(
							'.questExplain' + clickedlevel
						);
						if ( qExplain ) {
							qExplain.classList.add( 'hidden' );
						}
					}
				}
			} );
			decisionInfo.addEventListener( 'click', function ( e ) {
				const clickedExp = e.target;
				const clickedLevel = clickedExp.dataset.level;
				const parentQsection = clickedExp.closest( '.questionOptions' );
				if (
					parentQsection &&
					parentQsection.classList.contains( 'inactive' )
				) {
					return;
				}
				e.stopPropagation();
				const currentExplain = document.querySelector(
					'.questExplain' + clickedLevel
				);
				if ( currentExplain ) {
					if (
						currentExplain.classList.contains( 'hidden' ) &&
						currentExplain.textContent !== ''
					) {
						currentExplain.classList.remove( 'hidden' );
					} else {
						currentExplain.classList.add( 'hidden' );
					}
				}

				return true;
			} );
			questionsOptions.append( decisionQA );
			const levelPrevious = level - 1;
			const previousSection = document.querySelector(
				'.questionOptions.level' + level
			);
			if ( level !== 7 && previousSection ) {
				previousSection.after( questionsOptions );
			} else {
				/* Insert after previous section */
				const level1 = level - 1;
				const referenceNodeExist = document.querySelector(
					'.questionOptions.level' + level1
				);
				if ( level1 !== 6 && referenceNodeExist ) {
					referenceNodeExist.after( questionsOptions );
				} else {
					decisionSection.append( questionsOptions );
				}
			}
		}
	}
}

/***************************************************************************
 * Create questions
 ***************************************************************************/
// questions, sections, pathways, infeasibleQs, decisionData
function createPathwayQuestions( level, qindex, decisionData ) {
	const displaySection = document.querySelector(
		'.questionOptions.level' + level
	);
	const allCrumbs = document.querySelectorAll( '.crumb' );
	allCrumbs.forEach( function ( crumb ) {
		crumb.classList.remove( 'invalidCrumb' );
	} );
	if ( displaySection ) {
		const existingQustions =
			displaySection.querySelector( '.questionSection' );
		if ( existingQustions ) {
			/* This resets infeasible options etc, and questions are re-inserted */
			existingQustions.remove();
		}
		const questionSection = createCustomElement( 'section', {
			class: [ 'questionSection', 'level' + level ],
		} );

		const newQuestions = checkPathwayRoute( qindex, decisionData.pathways );
		const filteredQuestions = decisionData.questions.filter( ( _, index ) =>
			newQuestions.includes( index )
		);
		if ( filteredQuestions.length === 0 ) {
			checkValidity( decisionData );
		}

		filteredQuestions.forEach( function ( el, i ) {
			const allQIndex = decisionData.questions.findIndex(
				( quest ) => quest[ 0 ] === el[ 0 ]
			);
			const questionCode = el[ 0 ];
			const questionTextFull = el[ 1 ];
			const questionText = splitLines( questionTextFull );
			const question = createCustomElement(
				'div',
				{ class: [ 'choice', 'decisionBtn' ] },
				{
					'data-qindex': allQIndex,
					'data-code': el[ 0 ],
					'data-level': level,
				},
				questionText[ 0 ]
			);
			if ( questionText[ 1 ] ) {
				const subtext = createCustomElement(
					'span',
					{ class: [ 'choiceSubTitle' ] },
					{
						'data-qindex': allQIndex,
						'data-code': el[ 0 ],
						'data-level': level,
					},
					questionText[ 1 ]
				);
				question.append( subtext );
			}
			if ( questionText[ 2 ] ) {
				const subtext2 = createCustomElement(
					'span',
					{ class: [ 'choiceSubTitle' ] },
					{
						'data-qindex': allQIndex,
						'data-code': el[ 0 ],
						'data-level': level,
					},
					questionText[ 2 ]
				);
				question.append( subtext2 );
			}
			question.addEventListener(
				'click',
				( question.fn = function fn( ev ) {
					const ansCode = el[ 0 ];
					const ansText = el[ 1 ];
					const ansShort = el[ 2 ];
					const ansShort2 = el[ 3 ];
					const existingDecision = document.querySelector(
						'.crumb.level' + level
					);
					const chosenButton = ev.target;
					const parentSection = chosenButton.closest( 'section' );
					if ( parentSection ) {
						removeClassFromAll(
							parentSection,
							'div',
							'sectionChoice'
						);
					}
					chosenButton.classList.add( 'sectionChoice' );
					const chosenParent = chosenButton.closest( '.decisionBtn' );
					if ( chosenParent ) {
						chosenParent.classList.add( 'sectionChoice' );
					}

					/* Exceptions for 8B, 8C, 10B and 10C -- March 2025 question 10B1 assumed for 10B, 10B2  removed*/
					if ( existingDecision ) {
						reviseAnswer(
							existingDecision,
							allQIndex,
							ansCode,
							ansText,
							ansShort,
							ansShort2,
							level,
							decisionData
						);
					} else {
						recordAnswer(
							allQIndex,
							ansCode,
							ansText,
							ansShort,
							ansShort2,
							level,
							decisionData
						);
					}
					const explainations =
						document.querySelectorAll( '.questExplain' );
					explainations.forEach( ( el ) => {
						el.classList.add( 'hidden' );
					} );

					if ( level === 8 ) {
						const skipTwoLevels = [ '8A', '8D', '8E' ]; // Question 8C will be revised

						if ( skipTwoLevels.includes( ansCode ) ) {
							recordDummyAnswer( qindex, 'xx', '9' );
							recordDummyAnswer( qindex, 'xx', '10' );
							const hideQsection10 = document.querySelector(
								'.questionOptions.level10'
							);
							if ( hideQsection10 ) {
								hideQsection10.classList.add( 'hidden' );
							}
							const hideQsection9 = document.querySelector(
								'.questionOptions.level9'
							);
							if ( hideQsection9 ) {
								hideQsection9.classList.add( 'hidden' );
							}
						} else if ( ansCode == '8B' ) {
							recordDummyAnswer( qindex, 'xx', '9' ); // Question 9BX will be revised (to preserve order)
							recordDummyAnswer( qindex, 'xx', '10' );
							const hideQsection = document.querySelector(
								'.questionOptions.level10'
							);
							if ( hideQsection ) {
								hideQsection.classList.add( 'hidden' );
							}
						} else if ( ansCode == '8C' ) {
							recordDummyAnswer( qindex, 'xx', '9' );
							const hideQsection = document.querySelector(
								'.questionOptions.level9'
							);
							if ( hideQsection ) {
								hideQsection.classList.add( 'hidden' );
							}
						}
					}
					/* These are for levels 8C and 8B (10) */
					if ( level === 9 ) {
						recordDummyAnswer( qindex, 'xx', '10' );
					}
					if ( level === 10 ) {
						// clickedCrumb = decision
						recordDummyAnswer( qindex, 'xx', '9' );
					}
					const skipLastLevels = [ '10A', '10D' ]; //
					if ( level === 12 ) {
						if ( skipLastLevels.includes( ansCode ) ) {
							recordDummyAnswer( qindex, 'xx', '13' );
							recordDummyAnswer( qindex, 'xx', '14' );
							const hideQsection = document.querySelector(
								'.questionOptions.level14'
							);
							if ( hideQsection ) {
								hideQsection.classList.add( 'hidden' );
							}
						} else if ( ansCode === '10B' ) {
							//qindex = '101';
							recordDummyAnswer( qindex, '10B1', '13' ); // exception - 10B1 only
							//qindex = '102';
							recordDummyAnswer( qindex, 'xx', '14' );
							const hideQsection = document.querySelector(
								'.questionOptions.level14'
							);
							if ( hideQsection ) {
								hideQsection.classList.add( 'hidden' );
							}
						} else if ( ansCode === '10C' ) {
							recordDummyAnswer( qindex, 'xx', '13' );
							const hideQsection = document.querySelector(
								'.questionOptions.level13'
							);
							if ( hideQsection ) {
								hideQsection.classList.add( 'hidden' );
							}
						}
					}

					nextLevelQuestions( ev, decisionData );
					const crumbNavigation = document.querySelector(
						'#crumbsDecisionNavigation'
					);
					const possiblePaths =
						crumbNavigation.querySelectorAll( '.crumb' );
					if ( level < 8 ) {
						checkValidity( decisionData, 'Diet' );
					} else if ( level > 7 && level < 15 ) {
						checkValidity( decisionData, 'Food' );
					}
				} ),
				false
			);

			questionSection.append( question );
		} );

		displaySection.append( questionSection );

		makeParentActive( questionSection );
		const decisionSection = document.querySelector(
			'.mainDecisionSupport.decisionsupportToolbox'
		);
		const qSection = document.querySelector(
			'.decisionQA.question' + level
		);
		if ( decisionSection && qSection && level > 1 ) {
			const decisionOffset = decisionSection.offsetTop + 10;
			const questionHeight = qSection.offsetHeight;
			const myOffset = questionHeight * level + decisionOffset;
			//console.log('scrolling level is ' + level);
			window.scroll( 0, myOffset );
		}
	}
}

/***************************************************************************
 * checkPathwayRoute
 ***************************************************************************/

function checkPathwayRoute( qindex, pathways ) {
	const pathwayRow = pathways[ qindex ];
	const nextNodes = [];
	pathwayRow.forEach( ( value, index ) => {
		if ( value === '1' || value === '2' ) {
			nextNodes.push( index );
		}
	} );
	return nextNodes;
}

/***************************************************************************
 * Invalid quesitons according to pathway matrix (currently unused )
 ***************************************************************************/

function checkPathwayInvalid( qindex, pathways ) {
	const pathwayRow = pathways[ qindex ];
	const invalidNodes = [];
	pathwayRow.forEach( ( value, index ) => {
		if ( value === '2' ) {
			invalidNodes.push( index );
		}
	} );
	return invalidNodes;
}

/***************************************************************************
 * Record answer (new crumb)
 ***************************************************************************/

function recordAnswer(
	qindex,
	ansCode,
	ansText,
	ansShort,
	ansShort2,
	level,
	decisionData
) {
	closeQuestions();
	const crumbNavigation = document.querySelector(
		'#crumbsDecisionNavigation'
	);
	if ( crumbNavigation ) {
		const qLevel = Number( level ) - 1;
		const decisionCrumb = createCustomElement(
			'div',
			{ class: [ 'crumb', 'decision', 'level' + level ] },
			{
				'data-level': level,
				'data-code': ansCode,
				'data-qindex': qindex,
			},
			ansShort
		);
		decisionCrumb.addEventListener( 'click', function ( e ) {
			crumbListener( e, decisionData );
		} );
		crumbNavigation.append( decisionCrumb );

		const decision = createCustomElement(
			'div',
			{ class: [ 'crumb', 'answer', 'anslevel' + level ] },
			{
				'data-level': level,
				'data-code': ansCode,
				'data-qindex': qindex,
			},
			ansShort2
		);
		const decisionA = document.querySelector( 'section.decisionA' + level );
		if ( decisionA ) {
			const ansDiv = decisionA.querySelector( '.crumb.answer' );
			if ( ansDiv ) {
				ansDiv.textContent = ansShort2;
			} else {
				decisionA.append( decision );
			}
		}
	}
}

/***************************************************************************
 * Revise answer (crumb)
 ***************************************************************************/

function reviseAnswer(
	existingDecision,
	qindex,
	ansCode,
	ansText,
	ansShort,
	ansShort2,
	level,
	decisionData
) {
	closeQuestions();

	const currentCode = existingDecision.dataset.code;
	if ( currentCode === 'xx' ) {
		existingDecision.addEventListener( 'click', function ( e ) {
			crumbListener( e, decisionData );
		} );
	}
	existingDecision.textContent = ansShort; //level + ". " + ansCode + ". " +
	existingDecision.dataset.code = ansCode;
	existingDecision.dataset.qindex = qindex;
	existingDecision.classList.remove( 'tempDisabled' );
	existingDecision.classList.add( 'answered' );
	const previousSibs = getPreviousSiblings( existingDecision );
	previousSibs.forEach( function ( el ) {
		el.classList.remove( 'tempDisabled' );
	} );

	const existingAnswer = document.querySelector( '.anslevel' + level );

	if ( existingAnswer ) {
		existingAnswer.dataset.code = ansShort2;
		existingAnswer.textContent = ansShort2; //level + ". " + ansCode + ". " +
		existingAnswer.dataset.qindex = qindex;
	} else {
		const decisionA = document.querySelector( 'section.decisionA' + level );
		//const decisionParent = decisionA.closest('.decisionQA');
		//const decisionParentTitle = decisionParent.getAttribute('title');

		const decision = createCustomElement(
			'div',
			{ class: [ 'crumb', 'answer', 'mytestX', 'anslevel' + level ] },
			{
				'data-level': level,
				'data-code': ansCode,
				'data-qindex': qindex,
			},
			ansShort2
		);

		decisionA.textContent = '';
		decisionA.classList.add( 'answered' );
		const ansDiv = decisionA.querySelector( '.crumb.answer' );
		if ( ansDiv ) {
			ansDiv.textContent = ansShort2;
			// console.log(decisionParentTitle);
			// ansDiv.setAttribute('title', decisionParentTitle);
		} else {
			decisionA.append( decision );
			// console.log(decisionParentTitle);
			// decision.setAttribute('title',decisionParentTitle);
		}
	}
}

/***************************************************************************
 * listner on Crumbs - Only works when crumbs visible / admin
 ***************************************************************************/

function crumbListener( e, decisionData ) {
	const displaySection = document.querySelector( '.recommendReached' );
	if ( displaySection ) {
		displaySection.classList.remove( 'recommendReached' );
	}
	/* TODO -if the decision is revised, check that the listener is still valid) */
	const clickedCrumb = e.target;
	const previousCrumb = clickedCrumb.previousSibling;
	/* hide elements after ?*/
	const previousSibs = getPreviousSiblings( clickedCrumb );
	previousSibs.forEach( function ( el ) {
		el.classList.remove( 'tempDisabled' );
		el.classList.add( 'answered' );
	} );

	let levelprevious = 1;
	let codePrevious = 0;

	if ( previousCrumb ) {
		levelprevious = Number( clickedCrumb.dataset.level );
		codePrevious = Number( previousCrumb.dataset.qindex );
		const nextEls = getNextSiblings( clickedCrumb );
		nextEls.forEach( function ( el ) {
			el.classList.add( 'tempDisabled' );
			el.classList.remove( 'answered' );
		} );
	} else {
		const nextEls = getNextSiblings( clickedCrumb );
		nextEls.forEach( function ( el ) {
			el.classList.add( 'tempDisabled' );
			el.classList.remove( 'answered' );
		} );
	}

	reviseQuestions( previousCrumb, decisionData );
}

/***************************************************************************
 * Record placeholder answer  (crumb)
 ***************************************************************************/

function recordDummyAnswer( qindex, ansCode, level ) {
	const crumbNavigation = document.querySelector(
		'#crumbsDecisionNavigation'
	);
	const crumbByLevelExists = document.querySelector( '.crumb.level' + level );
	const parentSection = document.querySelector(
		'.questionOptions.level' + level
	);
	if ( crumbByLevelExists ) {
		crumbByLevelExists.textContent = ansCode; //level + ". " + ansCode + ". " +
		//        crumbByLevelExists.textContent = level + ". " + ansCode + " xx";
		crumbByLevelExists.dataset.code = ansCode;

		crumbByLevelExists.dataset.qindex = qindex;
		crumbByLevelExists.classList.remove( 'tempDisabled' );
		crumbByLevelExists.classList.add( 'answered' );
		if ( qindex !== 'xx' ) {
			crumbByLevelExists.classList.remove( 'dummydecision' );
		} else {
			crumbByLevelExists.classList.add( 'dummydecision' );
		}

		/* Todo - what this for? - see other */
		const previousCrumb = crumbByLevelExists.previousSibling;
		/* hide elements after ?*/
		const previousSibs = getPreviousSiblings( crumbByLevelExists );
		previousSibs.forEach( function ( el ) {
			el.classList.remove( 'tempDisabled' );
		} );
		ansCode = 'Section not yet answered';
		const decision2 = createCustomElement(
			'div',
			{ class: [ 'crumb', 'answer', 'dummyanswer', 'anslevel' + level ] },
			{
				'data-level': level,
				'data-code': ansCode,
				'data-qindex': qindex,
				title: ansCode,
			},
			ansCode
		);
		const decisionA = document.querySelector( 'section.decisionA' + level );
		if ( decisionA ) {
			if ( parentSection && ansCode === 'xx' ) {
				parentSection.classList.add( 'hidden' );
			}
			const ansDiv = decisionA.querySelector( '.crumb.answer' );
			if ( ansDiv ) {
				ansDiv.textContent = ansCode;
			} else {
				decisionA.append( decision2 );
			}
		}
	} else {
		if ( crumbNavigation ) {
			const qLevel = Number( level ) - 1;
			const decision = createCustomElement(
				'div',
				{
					class: [
						'crumb',
						'decision',
						'dummydecision',
						'level' + level,
					],
				},
				{
					'data-level': level,
					'data-code': ansCode,
					'data-qindex': qindex,
					title: ansCode,
				},
				ansCode
			);
			crumbNavigation.append( decision );
		}
		const decision2 = createCustomElement(
			'div',
			{ class: [ 'crumb', 'answer', 'dummyanswer', 'anslevel' + level ] },
			{
				'data-level': level,
				'data-code': ansCode,
				'data-qindex': qindex,
				title: ansCode,
			},
			ansCode
		);
		const decisionA = document.querySelector( 'section.decisionA' + level );
		if ( decisionA ) {
			if ( parentSection && ansCode === 'xx' ) {
				parentSection.classList.add( 'hidden' );
			}

			const ansDiv = decisionA.querySelector( '.crumb.answer' );
			if ( ansDiv ) {
				ansDiv.textContent = ansCode;
			} else {
				decisionA.append( decision2 );
			}
		}
	}
}
/***************************************************************************
 * Find decisions
 ***************************************************************************/

function checkValidity( decisionData, displayType = 'Diet' ) {
	const recommendationsData = new Object();
	recommendationsData.diet = checkDietPathways( decisionData );
	recommendationsData.food = checkFoodPathways( decisionData );

	if ( displayType === 'Diet' ) {
		const decisions = document.querySelectorAll(
			'#crumbsDecisionNavigation div.decision.diet.answered'
		);
		recommendationsData.answered = decisions.length;
		/* let lastQuestion = true;
        const lastCrumb = document.querySelector('div.decision.level12');*/
		// && lastQuestion

		if ( decisions.length > 6 ) {
			const resultsSection = document.querySelector(
				'.mainDecisionResult'
			);
			resultsSection.classList.remove( 'hidden' );
			resultsSection.classList.add( 'recommendReached' );
			displayDecision( decisionData, recommendationsData, 'Diet' );
		}
	} else if ( displayType === 'Food' ) {
		const decisions = document.querySelectorAll(
			'#crumbsDecisionNavigation div.decision.food.answered'
		);
		recommendationsData.answered = decisions.length;

		if ( decisions.length > 6 ) {
			const resultsSection = document.querySelector(
				'.mainDecisionResult'
			);
			resultsSection.classList.remove( 'hidden' );
			resultsSection.classList.add( 'recommendReached' );
			displayDecision( decisionData, recommendationsData, 'Food' );
		}
	} else if ( displayType === 'Urban' ) {
		displayDecision( decisionData, recommendationsData, 'Urban' );
	}

	return recommendationsData;
}

/***************************************************************************
 * Decision stage
 ***************************************************************************/

function displayDecision( decisionData, recommendationData, type = 'Diet' ) {
	//console.log('displaying the decision for ' + type);
	/* Switch various classes to collapse questions and show Kits */

	const explainations = document.querySelectorAll( '.questExplain' );
	const explaination = document.querySelector(
		'.questionExplainationSection'
	);
	explainations.forEach( ( el ) => {
		el.classList.add( 'hidden' );
	} );
	if ( explaination ) {
		explaination.classList.add( 'hidden' );
	}

	const decisionNote = document.querySelector( '.decisionSubSection' );
	decisionNote.classList.add( 'hidden' );

	const decisionSection = document.querySelector( '.mainDecisionResult' );
	decisionSection.classList.remove( 'hidden' );
	const qaSections = document.querySelectorAll( '.qaSection' );
	const navSections = document.querySelectorAll( '.decisionNav' );
	const dietSection = document.querySelector( '.dietContainer' );
	const foodSection = document.querySelector( '.foodContainer' );
	if ( ! decisionSection.classList.contains( 'foodKitsDisplayed' ) ) {
		dietSection.classList.add( 'hidden' );
		foodSection.classList.add( 'hidden' );
	}

	const dietNav = document.querySelector( '.dietNav' );
	const foodNav = document.querySelector( '.foodNav' );
	const decisionNav = document.querySelector( '.recommendationNav' );
	//decisionNav.classList.add('active');
	decisionNav.classList.remove( 'hidden' );
	let kitCodes;
	if ( type === 'Diet' ) {
		kitCodes = decisionData.dietKits.find(
			( el ) => el[ 0 ] === recommendationData.diet.kit
		);
	} else if ( type === 'Food' ) {
		kitCodes = decisionData.foodKits.find(
			( el ) => el[ 0 ] === recommendationData.food.kit
		);
	} else if ( type === 'Urban' ) {
		kitCodes = decisionData.foodKits.find(
			( el ) => el[ 0 ] === 'urban_considerations'
		);
	}
	/* Kit Display section */
	const displaySection = document.querySelector( '.recommendSection' + type );

	if ( displaySection ) {
		getKitPage( kitCodes, displaySection, type, decisionData );
		decisionSection.classList.add( 'foodKitsDisplayed' );
	}

	const foodBtnHide = document.querySelector( '.recommendBtn.recommendFood' );
	const dietBtnHide = document.querySelector( '.recommendBtn.recommendDiet' );
	const foodDecisions = document.querySelectorAll(
		'#crumbsDecisionNavigation div.decision.food.answered'
	);
	const dietDecisions = document.querySelectorAll(
		'#crumbsDecisionNavigation div.decision.diet.answered'
	);
	if ( foodDecisions.length > 6 ) {
		foodBtnHide.classList.remove( 'notCompleted' );
	} else {
		foodBtnHide.classList.add( 'notCompleted' );
	}
	if ( dietDecisions.length > 6 ) {
		dietBtnHide.classList.remove( 'notCompleted' );
	} else {
		dietBtnHide.classList.add( 'notCompleted' );
	}
}

/***************************************************************************
 * Display recommendations - load page/resource contents
 ***************************************************************************/

function getKitPage( codekit, displaySection, type, decisionData ) {
	const toolSections = document.querySelectorAll( '.nutitionRecSection' );
	toolSections.forEach( ( toolSection ) =>
		toolSection.classList.add( 'hidden' )
	);

	// console.log(type);

	//console.log(displaySection)
	if ( ! codekit ) {
		empty( displaySection );
		const noKitMsg = createCustomElement(
			'h4',
			{},
			{},
			'The current combination of ' +
				type +
				' choices did not result in any recommended tools.'
		);
		displaySection.append( noKitMsg );
		displaySection.classList.remove( 'hidden' );
	} else {
		const code = codekit[ 0 ];
		const codeURL = codekit[ 1 ];
		const currentCode = displaySection.dataset.codekit;
		if ( currentCode === code ) {
			displaySection.classList.remove( 'hidden' );
		} else {
			empty( displaySection );
			const apiPath = 'decision-support/v1/gettools';
			apiFetch( {
				path: apiPath,
				method: 'POST',
				data: { url: codeURL },
			} ).then( ( contentData ) => {
				displaySection.classList.remove( 'hidden' );
				displaySection.innerHTML = contentData;
				displaySection.classList.add( 'retreivedResults' );
				displaySection.dataset.codekit = code;

				const downloadResults = createCustomElement(
					'button',
					{ class: [ 'nutritionBtn', 'nutritionBtnKit' ] },
					{},
					'Download results'
				);
				displaySection.prepend( downloadResults );
				downloadResults.addEventListener( 'click', function ( evt ) {
					displayResultsDialog( decisionData );
				} );
			} );
		}
	}
}

/***************************************************************************
 * Check infesible combinations (InfeasibleCombinations tab in spreadsheet)
 * New version September 2025
 ***************************************************************************/
function checkLevelCombinations(
	decisions,
	infeasibleQs,
	level,
	numAnswers = 0
) {
	//console.log('checking combinations')

	const returnVals = {};
	returnVals.codes = [];
	returnVals.texts = [];
	returnVals.choices = [];
	returnVals.types = [];

	/* Get current paths as array */
	const currentActive = document.querySelector(
		'.questionOptions:not(.inactive)'
	);
	const levelCheck = currentActive.dataset.level;
	const levelNum = Number( level );
	const crumbNavigation = document.querySelector(
		'#crumbsDecisionNavigation'
	);
	const possiblePaths = crumbNavigation.querySelectorAll( '.crumb' );
	const currentPaths = crumbNavigation.querySelectorAll( '.decision' );
	const testingPath = [];
	const adjustLength = 0; // For paths lie 10C

	if ( levelNum < possiblePaths.length + 1 ) {
		for ( let i = 0; i < levelNum - 1; i++ ) {
			testingPath.push( currentPaths[ i ].dataset.code );
		}
	}

	/* Get infeasible paths as either one two or 3 */
	infeasibleQs.forEach( function ( notFeasible, i ) {
		const infLength = notFeasible[ 0 ].length;
		let indx1 = Number( notFeasible[ 0 ][ 0 ] ) - 1;
		if ( indx1 === 8 ) {
			/* this is added because there are paths for 8B and 8C */
			/* Currently only tested on one rule 9B	invalidates 10C1 */
			indx1 = indx1 + 2;
			// console.log(indx1)
		}

		switch ( infLength ) {
			case 2:
				if ( testingPath[ indx1 ] === notFeasible[ 0 ] ) {
					returnVals.choices.push( notFeasible[ 0 ] );
					returnVals.codes.push( notFeasible[ 1 ] );
					returnVals.texts.push( notFeasible[ 2 ] );
					returnVals.types.push( notFeasible[ 3 ] );
				}

				break;
			case 4:
				if ( testingPath.length < 2 ) {
					break;
				}
				const indx2 = Number( notFeasible[ 0 ][ 2 ] ) - 1;
				const comparator = testingPath[ indx1 ] + testingPath[ indx2 ];
				if ( comparator === notFeasible[ 0 ] ) {
					returnVals.choices.push( notFeasible[ 0 ] );
					returnVals.codes.push( notFeasible[ 1 ] );
					returnVals.texts.push( notFeasible[ 2 ] );
					returnVals.types.push( notFeasible[ 3 ] );
				}

				break;
			case 6:
				if ( testingPath.length < 3 ) {
					break;
				}
				//console.log("three");
				const indx2a = Number( notFeasible[ 0 ][ 2 ] ) - 1;
				const indx3 = Number( notFeasible[ 0 ][ 4 ] ) - 1;
				const comparator3 =
					testingPath[ indx1 ] +
					testingPath[ indx2a ] +
					testingPath[ indx3 ];
				if ( comparator3 === notFeasible[ 0 ] ) {
					returnVals.choices.push( notFeasible[ 0 ] );
					returnVals.codes.push( notFeasible[ 1 ] );
					returnVals.texts.push( notFeasible[ 2 ] );
					returnVals.types.push( notFeasible[ 3 ] );
				}
				break;
			case 8:
				//console.log("four");
				break;
			default:
			//console.log(`Sorry, we are out of options`);
		}
	} );

	if ( !! testingPath[ 2 ] ) {
		const Q3 = testingPath[ 2 ];
		//console.log( Q3 );

		const Q5 = document.querySelector( '.decisionQA.question5 div' );
		if ( Q3 === '3A' && Q5 ) {
			Q5.textContent =
				'Are you interested in measuring long-term consumption (consumption over the span of a month or year?)';
		} else if ( Q5 ) {
			Q5.textContent =
				'Are you interested in measuring long-term dietary intake (intake over the span of a month or year?)';
		}
	}

	//console.log(returnVals);
	return returnVals;
}

function checkLevelCombinationsPrevious(
	decisions,
	infeasibleQs,
	level,
	numAnswers = 0
) {
	const returnVals = {};
	returnVals.codes = [];
	returnVals.texts = [];
	returnVals.choices = [];

	if ( decisions.length > 1 ) {
		const Q1a = decisions[ 0 ].dataset.code;
		const rec_el1a = infeasibleQs.find( ( el ) => el[ 0 ] === Q1a );

		if ( rec_el1a ) {
			returnVals.codes.push( rec_el1a[ 1 ] );
			returnVals.texts.push(
				'Q1 option: Intake and adequacy of specific nutrients or micronutrients, makes this option infeasible'
			);
		}
	}
	if ( decisions.length > 2 ) {
		const Q1 = decisions[ 0 ].dataset.code;
		const Q2 = decisions[ 1 ].dataset.code; // For target group
		const Q3 = decisions[ 2 ].dataset.code;
		const rec_el = infeasibleQs.find( ( el ) => el[ 0 ] === Q1 + Q3 );
		const rec_el2 = infeasibleQs.find( ( el ) => el[ 0 ] === Q2 );
		let infeasibleopts1 = [];
		let infeasibleopts2 = [];
		let infeasibleopts3 = [];
		let infeasibleopts4 = [];
		const infeasibleopts5 = [];
		let infeasibleopts6 = [];
		let infeasibleText1 = [];
		const infeasibleText2 = [];
		const infeasibleText3 = [];
		const infeasibleText4 = [];
		const infeasibleText5 = [];
		const infeasibleText6 = [];

		if ( rec_el ) {
			infeasibleopts1 = rec_el[ 1 ].split( ',' );
			infeasibleText1 = rec_el[ 2 ];
			infeasibleopts1.forEach( function ( el, i ) {
				returnVals.texts[ i ] = infeasibleText1;
			} );
			returnVals.codes = infeasibleopts1;
			returnVals.choices.push( Q1 );
			returnVals.choices.push( Q3 );
		}
		if ( rec_el2 ) {
			infeasibleopts2 = rec_el2[ 1 ].split( ',' );
			infeasibleopts2.forEach( function ( el, i ) {
				if ( returnVals.codes.includes( el ) ) {
					const rec_index = returnVals.codes.indexOf( el );
					const combinedText =
						infeasibleText1 + ' AND ' + rec_el2[ 2 ];
					returnVals.texts[ rec_index ] = combinedText;
				} else {
					returnVals.codes.push( el );
					returnVals.texts.push( rec_el2[ 2 ] );
				}
			} );
			returnVals.choices.push( Q2 );
		}

		const thisline = new Error().lineNumber;
		if ( decisions.length > 3 ) {
			const Q4 = decisions[ 3 ].dataset.code;

			const rec_el4 = infeasibleQs.find( ( el ) => el[ 0 ] === Q4 );

			if ( rec_el4 ) {
				infeasibleopts4 = rec_el4[ 1 ].split( ',' );
				infeasibleopts4.forEach( function ( el, i ) {
					if ( returnVals.codes.includes( el ) ) {
						const rec_index = returnVals.codes.indexOf( el );
						const combinedText =
							infeasibleText4 + ' AND ' + rec_el4[ 2 ];
						returnVals.texts[ rec_index ] = combinedText;
					} else {
						returnVals.codes.push( el );
						returnVals.texts.push( rec_el4[ 2 ] );
					}
				} );
				returnVals.choices.push( Q4 );
			}

			//const Q4 = decisions[3].dataset.code
			const Q5 = document.querySelector( '.decisionQA.question5 div' );
			if ( Q3 === '3A' && Q5 ) {
				Q5.textContent =
					'Are you interested in measuring long-term consumption (consumption over the span of a month or year?)';
			} else {
				if ( Q5 ) {
					Q5.textContent =
						'Are you interested in measuring long-term dietary intake (intake over the span of a month or year?)';
				}
				/* else {

                    console.log ('TEST THIS AGAINST VERSION 2');
                }*/
			}
		}

		if ( decisions.length > 5 ) {
			const Q6 = decisions[ 5 ].dataset.code;
			const rec_el6 = infeasibleQs.find( ( el ) => el[ 0 ] === Q6 );

			if ( rec_el6 ) {
				infeasibleopts6 = rec_el6[ 1 ].split( ',' );
				infeasibleopts6.forEach( function ( el, i ) {
					if ( returnVals.codes.includes( el ) ) {
						const rec_index = returnVals.codes.indexOf( el );
						const combinedText =
							infeasibleText6 + ' AND ' + rec_el6[ 2 ];
						returnVals.texts[ rec_index ] = combinedText;
					} else {
						returnVals.codes.push( el );
						returnVals.texts.push( rec_el6[ 2 ] );
					}
				} );
				returnVals.choices.push( Q6 );
			}
		}
		if ( decisions.length > 10 ) {
			const Q9 = decisions[ 10 ].dataset.code; // For 10B
			if ( Q9 ) {
				const rec_el3 = infeasibleQs.find( ( el ) => el[ 0 ] === Q9 );
				if ( rec_el3 ) {
					infeasibleopts3 = rec_el3[ 1 ].split( ',' );

					infeasibleopts3.forEach( function ( el, i ) {
						returnVals.codes.push( el );
						returnVals.texts.push( rec_el3[ 2 ] );
					} );
				}

				returnVals.choices.push( Q9 );
			}
		}
	}
	return returnVals;
}

function checklevelPathways( decisionData ) {
	/*This section added extra, from line ~ 1296  - to check all pathways currently displayed are valid */
	/*Currently only for displayed section */
	const currentActive = document.querySelector(
		'.questionOptions:not(.inactive)'
	);
	const level = currentActive.dataset.level;
	const levelNum = Number( level );

	const crumbNavigation = document.querySelector(
		'#crumbsDecisionNavigation'
	);
	const currentPaths = crumbNavigation.querySelectorAll( '.decision' );
	let previousPath = '';

	let adjustLength = 0; // For paths like 10C

	if ( levelNum < 8 ) {
		for ( let i = 0; i < levelNum - 1; i++ ) {
			previousPath = previousPath + currentPaths[ i ].dataset.code;
		}
	} else if ( levelNum == 7 ) {
		return;
	} // DevNote impossible?
	else if ( levelNum > 7 && levelNum < 15 ) {
		for ( let i = 7; i < levelNum - 1; i++ ) {
			const length = currentPaths.length; // DevNote TEMPTEMP

			if (
				levelNum === 9 &&
				currentPaths[ i ].dataset.code.length == 3
			) {
				adjustLength = -1;
			}
			previousPath = previousPath + currentPaths[ i ].dataset.code;
			if ( levelNum === 9 ) {
				break;
			}
			if ( levelNum === 10 && i === 8 ) {
				//console.log( { adjustLength } );
				break;
			}
			if ( levelNum === 11 && i === 9 ) {
				break;
			}
			if ( levelNum === 12 && i === 10 ) {
				break;
			}
		}
	}
	const currentPathwayQs = document.querySelectorAll(
		'.questionSection.level' + level + ' .decisionBtn'
	);
	const validPaths = [];

	if ( levelNum < 8 ) {
		decisionData.dietPaths.forEach( function ( path ) {
			const pathPortion = path[ 0 ].substring( 0, previousPath.length );
			if ( pathPortion === previousPath && path[ 1 ] !== 'Fail' ) {
				validPaths.push( path );
			}
		} );
	} else if ( levelNum > 7 && levelNum < 15 ) {
		/* console.log('previousPath')
         console.log(previousPath)*/
		decisionData.foodPaths.forEach( function ( path, i ) {
			const pathPortion = path[ 0 ].substring(
				0,
				previousPath.length + adjustLength
			);
			/* if (i < 2) {           
                console.log('pathPortion')
                console.log(pathPortion)
            }*/

			if ( pathPortion === previousPath && path[ 1 ] !== 'Fail' ) {
				validPaths.push( path );
			}
		} );
	}

	currentPathwayQs.forEach( function ( currentQ ) {
		let aValidQ = false;
		currentQ.classList.remove( 'infeasibleOptionPath' );
		const AddPath = currentQ.dataset.code;
		const possiblePath = previousPath + AddPath;
		const possibleLength = possiblePath.length;
		for ( let i = 0; i < validPaths.length; i++ ) {
			/* if it matches one of the valid paths then this changes to true, breaks ... */
			if (
				validPaths[ i ][ 0 ].substring( 0, possibleLength ) ===
				possiblePath
			) {
				aValidQ = true;
				break;
			}
		}

		/* If no matches */
		if ( ! aValidQ ) {
			/* InfeasibleOptionPath calculated from available paths  */
			if ( ! currentQ.classList.contains( 'invalidCombination' ) ) {
				currentQ.classList.add( 'infeasibleOptionPath' );
				currentQ.removeEventListener( 'click', currentQ.fn, false );
				currentQ.addEventListener( 'click', function ( e ) {
					const clickedQ = e.target;
					const originalText = clickedQ.textContent;
					clickedQ.textContent = 'Infeasible Path';
					window.setTimeout( function () {
						clickedQ.textContent = originalText;
					}, 3000 );
				} );
			}
			/* End ---InfeasibleOptionPath calculated from available paths  */
		}
	} );
}

function markInfeasible( decisionData, level ) {
	/*  const allInfeasible = false;
     if (returnVals.codes.length === 5) { allInfeasible = true; } */
	/* markInfeasible(Q1, Q2, allInfeasible) */
	const allbuttons = document.querySelectorAll( 'div.choice' );
	allbuttons.forEach( ( el ) => {
		//el.classList.remove('invalidPath,');
		el.classList.remove(
			'partialInvalidPath',
			'invalidPath',
			'exceptionInvalidPath'
		);
	} );
	const allSections = document.querySelectorAll( '.questionOptions' );
	allSections.forEach( ( el ) => {
		el.classList.remove( 'invalidChildEls' );
	} );
	const decisions = document.querySelectorAll(
		'#crumbsDecisionNavigation div.decision'
	);
	const numberAnswers = decisions.length;
	const infeasibleClass = 'partialInvalidPath';
	const infeasibleCombos = checkLevelCombinations(
		decisions,
		decisionData.infeasibleQs,
		level,
		numberAnswers
	);
	if ( infeasibleCombos.choices ) {
		infeasibleCombos.choices.forEach( ( elm ) => {
			const markEl1 = document.querySelector(
				'div.choice[data-code="' + elm + '"]'
			);

			if ( markEl1 ) {
				markEl1.classList.add( infeasibleClass );

				const relatedParent = markEl1.closest( '.questionOptions' );
				if ( relatedParent ) {
					relatedParent.classList.add( 'invalidChildEls' );
				}
			}
		} );

		infeasibleCombos.codes.forEach( ( option, i ) => {
			/*DevNote - check this - no longer relevant? 1A3B */
			//console.log(i)
			//console.log(option)
			//console.log(infeasibleCombos.texts[i])
			if ( option === 'Exception' ) {
				infeasibleCombos.choices.forEach( ( elm ) => {
					const markEl1 = document.querySelector(
						'div.choice[data-code="' + elm + '"]'
					);
					if ( markEl1 ) {
						markEl1.classList.add( 'exceptionInvalidPath' );
					}
				} );
			}
			const question = document.querySelector(
				'div.choice[data-code="' + option + '"]'
			);
			if ( question ) {
				if ( infeasibleCombos.types[ i ] === '1' ) {
					question.classList.add( 'incompleteCombination' );

					question.addEventListener( 'mouseover', function ( e ) {
						const clickedQ = e.target;
						const originalText = clickedQ.textContent;
						clickedQ.dataset.original = originalText;
						clickedQ.classList.add( 'noticeText' );
						//clickedQ.textContent = "This option is not available in combination with previous choices ";
						clickedQ.textContent = infeasibleCombos.texts[ i ];
						/* window.setTimeout(function () {
                           clickedQ.textContent = originalText;
                           clickedQ.classList.remove('noticeText')
                           
                           }, 3000) */
					} );
					question.addEventListener( 'mouseout', function ( e ) {
						const clickedR = e.target;
						clickedR.classList.remove( 'noticeText' );
						const originalText = clickedR.dataset.original;
						clickedR.textContent = originalText;
					} );
				} else {
					question.classList.add( 'invalidCombination' );
					question.removeEventListener( 'click', question.fn, false );
					// debugger;
					question.addEventListener( 'mouseover', function ( e ) {
						const clickedQ = e.target;
						const originalText = clickedQ.textContent;
						clickedQ.dataset.original = originalText;

						//clickedQ.textContent = "This option is not available in combination with previous choices ";
						clickedQ.textContent = infeasibleCombos.texts[ i ];
						const decisionContainer = document.querySelector(
							'.mainDecisionSupport'
						);
						if ( decisionContainer ) {
							decisionContainer.classList.add(
								'highlightInvalid'
							);
						}
					} );
					question.addEventListener( 'mouseout', function ( e ) {
						const clickedR = e.target;
						clickedR.classList.remove( 'noticeText' );
						const originalText = clickedR.dataset.original;
						clickedR.textContent = originalText;
					} );
				}
			}
		} );
	}
}

function checkDietPathways( decisionData ) {
	const validPaths = [];
	const dietValidity = new Object();
	dietValidity.status = 'unknown';
	dietValidity.kit = 'incomplete';
	dietValidity.kitname = 'incomplete';
	const crumbNavigation = document.querySelector(
		'#crumbsDecisionNavigation'
	);
	const currentPaths = crumbNavigation.querySelectorAll( '.decision.diet' );
	const currentDisplayedPaths = document.querySelectorAll( '.answer' );
	/* For extra info (shown to admin) */
	const currentDietPathI = document.querySelector( '.currentDietPathInfo' );
	const currentDietRes = document.querySelector( '.currentDietResAdmin' );

	let currentPath = '';
	const currentPathArray = [];
	if ( crumbNavigation ) {
		currentPaths.forEach( function ( decision ) {
			currentPath = currentPath + decision.dataset.code;
			currentPathArray.push( decision.dataset.code );
		} );
		currentDisplayedPaths.forEach( function ( el ) {
			el.classList.remove( 'dietInfeasible' );
			el.title = '';
		} );
	}

	decisionData.dietPaths.forEach( function ( path ) {
		if (
			path[ 1 ] !== undefined &&
			path[ 1 ] !== 'Fail' &&
			! validPaths.includes( path[ 0 ] )
		) {
			validPaths.push( path[ 0 ].substring( 0, currentPath.length ) );
		}
	} );

	const dietHeader = document.querySelector( '.dietPathwayStatus' );
	if ( dietHeader ) {
		dietHeader.classList.remove( 'initial' );
		const currentDietPath = currentPath.substring( 0, 14 );
		/* For copy-paste for testing */
		const pathInfo = document.querySelector( '#crumbDecisions' );

		if ( pathInfo ) {
			pathInfo.textContent = currentDietPath;
		}
		const decisionDietAdmin = document.querySelector(
			'#decisionDietPathways'
		);
		if ( testingModeEnabled && decisionDietAdmin ) {
			filterDecisionDietTable( currentDietPath, decisionDietAdmin );
		}
		/* End copy-paste for testing */
		if (
			currentPath.length > 13 &&
			validPaths.includes( currentDietPath )
		) {
			const rec_el = decisionData.dietPaths.find(
				( el ) => el[ 0 ] === currentDietPath
			);
			if ( rec_el ) {
				dietHeader.title = 'Diet toolkit: ' + rec_el[ 2 ];
				dietHeader.dataset.currentpath = currentDietPath;
				dietHeader.classList.remove( 'dietInValid' );
				dietHeader.classList.add( 'dietValid' );
				dietValidity.status = 'valid';
				dietValidity.kit = rec_el[ 1 ];
				dietValidity.kitname = rec_el[ 2 ];
				currentDietPathI.textContent = currentDietPath;
				currentDietRes.textContent =
					dietValidity.kit + ' / ' + dietValidity.kitname;
				currentDietRes.dataset.kitname = dietValidity.kitname;
				const kitLookup = decisionData.dietKits.find(
					( el ) => el[ 0 ] === rec_el[ 1 ]
				);
				currentDietRes.dataset.kitcode = kitLookup[ 0 ];
				currentDietRes.dataset.kitpath = kitLookup[ 1 ];
				currentDietRes.dataset.kitpdf = kitLookup[ 2 ];
			}
		} else if ( validPaths.includes( currentPath ) ) {
			dietHeader.title = 'Current Diet path is valid: ' + currentDietPath;
			dietHeader.dataset.currentpath = currentDietPath;
			dietHeader.classList.remove( 'dietInValid' );
			dietHeader.classList.add( 'dietValid' );
			dietValidity.status = 'valid';
			currentDietPathI.textContent = currentDietPath;
			currentDietRes.textContent = 'Feasible';
		} else {
			dietHeader.title =
				'Current DIET path is Infeasible: ' + currentDietPath;
			if ( currentDisplayedPaths[ 3 ] && currentPaths.length > 3 ) {
				currentDisplayedPaths[ 3 ].classList.add( 'dietInfeasible' );
				currentDisplayedPaths[ 3 ].title =
					'The current combination of choices will not result in any recommended tools. Please revise this or earlier choices!';

				currentDietRes.textContent = 'Current DIET path is Infeasible';
			}
			currentDietPathI.textContent = currentDietPath;
			dietHeader.dataset.currentpath = currentDietPath;
			dietHeader.classList.remove( 'dietValid' );
			dietHeader.classList.add( 'dietInValid' );
			dietValidity.status = 'invalid';
		}
		dietValidity.currentDietPath = currentDietPath;
	}
	return dietValidity;
}

function checkFoodPathways( decisionData ) {
	const validPaths = [];
	const foodValidity = new Object();
	foodValidity.status = 'unknown';
	foodValidity.kit = 'incomplete';
	foodValidity.kitname = 'incomplete';

	/* For display (currently admin) */
	const currentFoodPathI = document.querySelector( '.currentFoodPathInfo' );
	const currentFoodRes = document.querySelector( '.currentFoodResAdmin' );
	const crumbNavigation = document.querySelector(
		'#crumbsDecisionNavigation'
	);
	const currentPaths = crumbNavigation.querySelectorAll( '.decision.food' );
	let currentPath = '';
	if ( crumbNavigation ) {
		// console.log(crumbNavigation);
		if ( currentPaths.length === 0 ) {
			return;
		}
		for ( let step = 0; step < currentPaths.length; step++ ) {
			currentPath = currentPath + currentPaths[ step ].dataset.code;
		}
	}
	decisionData.foodPaths.forEach( function ( path ) {
		const pathPortion = path[ 0 ].substring( 0, currentPath.length );
		if (
			path[ 1 ] !== undefined &&
			path[ 1 ] !== 'Fail' &&
			! validPaths.includes( pathPortion )
		) {
			validPaths.push( pathPortion );
		}
	} );
	const foodHeader = document.querySelector( '.foodPathwayStatus' );
	//console.log('The number of decisions is currently ' + currentPaths.length);
	const currentFoodPath = currentPath; // currentPath.substring(15,currentPath.length);
	if ( foodHeader ) {
		foodHeader.classList.remove( 'initial' );

		/* For copy-paste for testing */
		const pathInfo2 = document.querySelector( '#crumbDecisions2' );
		if ( pathInfo2 ) {
			pathInfo2.textContent = currentFoodPath;
		}

		const decisionFoodAdmin = document.querySelector(
			'#decisionFoodPathways'
		);
		if ( testingModeEnabled && decisionFoodAdmin ) {
			filterDecisionFoodTable( currentFoodPath, decisionFoodAdmin );
		}

		const rec_el = decisionData.foodPaths.find(
			( el ) => el[ 0 ] === currentPath
		);
		if ( rec_el && validPaths.includes( currentPath ) ) {
			foodHeader.title = 'Food environment toolkit: ' + rec_el[ 2 ];
			foodHeader.classList.remove( 'foodInValid' );
			foodHeader.classList.add( 'foodValid' );
			foodValidity.status = 'valid';
			foodValidity.kit = rec_el[ 1 ];
			foodValidity.kitname = rec_el[ 2 ];
			currentFoodPathI.textContent = currentPath;
			currentFoodRes.textContent =
				foodValidity.kit + ' / ' + foodValidity.kitname;
			currentFoodRes.dataset.kitname = foodValidity.kitname;

			const kitLookup = decisionData.foodKits.find(
				( el ) => el[ 0 ] === rec_el[ 1 ]
			);
			currentFoodRes.dataset.kitcode = kitLookup[ 0 ];
			currentFoodRes.dataset.kitpath = kitLookup[ 1 ];
			currentFoodRes.dataset.kitpdf = kitLookup[ 2 ];
		} else if ( validPaths.includes( currentPath ) ) {
			foodHeader.title =
				'Current Food environment path is valid: ' + currentPath;
			if ( currentPaths.length > 7 ) {
				foodHeader.classList.remove( 'foodInValid' );
				foodHeader.classList.add( 'foodValid' );
			}

			foodValidity.status = 'valid';
			currentFoodPathI.textContent = currentPath;
			currentFoodRes.textContent = 'Feasible';
		} else if ( currentPath === '8Bxxxx' ) {
			foodHeader.title = 'Current Food environment path is valid: 8B';
			if ( currentPaths.length > 7 ) {
				foodHeader.classList.remove( 'foodInValid' );
				foodHeader.classList.add( 'foodValid' );
			}

			foodValidity.status = 'valid';
			currentFoodPathI.textContent = currentPath;
			currentFoodRes.textContent = 'Feasible';
		} else {
			//console.log( 'checked this' );
			//console.log( currentFoodPath );
			//console.log( validPaths );
			foodHeader.title =
				'Current FOOD ENVIRONMENT path is Infeasible: ' + currentPath;
			foodHeader.classList.remove( 'foodValid' );
			foodHeader.classList.add( 'foodInValid' );
			foodValidity.status = 'invalid';
			currentFoodPathI.textContent = currentPath;
			currentFoodRes.textContent =
				'Current FOOD ENVIRONMENT path is Infeasible';
		}
		foodValidity.currentFoodPath = currentFoodPath;
	}
	return foodValidity;
}
/***************************************************************************
 * Next levels - called from createPathwayQuestions function
 ***************************************************************************/

function nextLevelQuestions( ev, decisionData ) {
	ev.preventDefault();
	const code = ev.target.dataset.code;
	const qindex = ev.target.dataset.qindex;
	let level = Number( ev.target.dataset.level );

	/* On questions 8B and 8C we go to 8C1, or 8C2, on 8C1 or 8C2 we go otherwise to Q9 */
	const skipTwoLevels = [ '8A', '8D', '8E', '10A', '10B', '10D', '10E' ];
	const skipOneLevel = [ '8C', '8B1', '8B2', '10C', '10B1', '10B2' ];
	if ( skipTwoLevels.includes( code ) ) {
		level = level + 2;
	}
	if ( skipOneLevel.includes( code ) ) {
		level = level + 1;
	}
	level = level + 1;
	if ( code === '10C' || code === '10C1' || code === '10C2' ) {
		//console.log( 'Levels 10C, 10C1 or 10C2 ' + code );
	}

	const nextSection = document.querySelector(
		'.decisionQA.question' + level
	);
	if ( level > 14 ) {
		checkValidity( decisionData );
		return;
	} else if ( nextSection ) {
		const recommendedAlready = document.querySelector(
			'.recommendSection.recommendReached'
		);
		if ( recommendedAlready ) {
			checkValidity( decisionData );
			return;
		}
		createPathwayQuestions( level, qindex, decisionData );
	} else {
		createSection( level, decisionData.sections );
		createPathwayQuestions( level, qindex, decisionData );
	}
	markInfeasible( decisionData, level );
	checklevelPathways( decisionData, level, 'Diet' );
}

/***************************************************************************
 * SHOW Diet all pathways - For testing only
 ***************************************************************************/

function showDietDecisionTable( decisionData, decisionAdmin ) {
	//const cachedTable = window.localStorage.getItem('decision_table')
	//const cachedData=[];

	//if (!cachedTable) {
	decisionData.dietPaths.forEach( function ( dietPath, i ) {
		const c = createCustomElement(
			'div',
			{ class: [ 'feasPathRow' ] },
			{ 'data-datapath': dietPath[ 0 ] }
		);
		const c1 = createCustomElement(
			'div',
			{ class: [ 'feasPath' ] },
			{},
			dietPath[ 0 ]
		);
		const c2 = createCustomElement(
			'div',
			{ class: [ 'feasPath' ] },
			{},
			dietPath[ 1 ]
		);
		const c3 = createCustomElement(
			'div',
			{ class: [ 'feasPath' ] },
			{},
			dietPath[ 2 ]
		);
		c.append( c1, c2, c3 );

		decisionAdmin.append( c );
	} );
	// const newHTML = decisionAdmin.innerHTML;
	// window.localStorage.setItem('decision_table', newHTML)

	/* }
     else {
         console.log(cachedTable);
         decisionAdmin.innerHTML = cachedTable;
     }*/
}

/***************************************************************************
 * SHOW Food all pathways - For testing only
 ***************************************************************************/

function showFoodDecisionTable( decisionData, decisionDietAdmin ) {
	//const cachedTable = window.localStorage.getItem('decision_table')
	//const cachedData=[];

	//if (!cachedTable) {
	decisionData.foodPaths.forEach( function ( foodPath, i ) {
		const c = createCustomElement(
			'div',
			{ class: [ 'feasPathRow' ] },
			{ 'data-datapath': foodPath[ 0 ] }
		);
		const c1 = createCustomElement(
			'div',
			{ class: [ 'feasPath' ] },
			{},
			foodPath[ 0 ]
		);
		const c2 = createCustomElement(
			'div',
			{ class: [ 'feasPath' ] },
			{},
			foodPath[ 1 ]
		);
		const c3 = createCustomElement(
			'div',
			{ class: [ 'feasPath' ] },
			{},
			foodPath[ 2 ]
		);
		c.append( c1, c2, c3 );

		decisionDietAdmin.append( c );
	} );
	// const newHTML = decisionAdmin.innerHTML;
	// window.localStorage.setItem('decision_table', newHTML)

	/* }
     else {
         console.log(cachedTable);
         decisionAdmin.innerHTML = cachedTable;
     }*/
}

function filterDecisionDietTable( currentDietPath, decisionDietAdmin ) {
	const currentSection = document.querySelector( '.food_diet_decision' );
	if ( currentSection.classList.contains( 'food' ) ) {
		decisionDietAdmin.classList.add( 'hidden' );
	} else {
		decisionDietAdmin.classList.remove( 'hidden' );
		const currentDietPathLen = currentDietPath.length;
		const feasPathRows =
			decisionDietAdmin.querySelectorAll( '.feasPathRow' );
		feasPathRows.forEach( function ( feaspath ) {
			const partialPath = feaspath.dataset.datapath.slice(
				0,
				currentDietPathLen
			);
			if ( partialPath === currentDietPath ) {
				feaspath.classList.remove( 'hidden' );
			} else {
				feaspath.classList.add( 'hidden' );
			}
		} );
	}
}

function filterDecisionFoodTable( currentFoodPath, decisionFoodAdmin ) {
	const currentSection = document.querySelector( '.food_diet_decision' );
	if ( currentSection.classList.contains( 'diet' ) ) {
		decisionFoodAdmin.classList.add( 'hidden' );
	} else {
		decisionFoodAdmin.classList.remove( 'hidden' );
		const currentFoodPathLen = currentFoodPath.length;
		const feasPathRows =
			decisionFoodAdmin.querySelectorAll( '.feasPathRow' );
		feasPathRows.forEach( function ( feaspath ) {
			const partialPath = feaspath.dataset.datapath.slice(
				0,
				currentFoodPathLen
			);
			if ( partialPath === currentFoodPath ) {
				feaspath.classList.remove( 'hidden' );
			} else {
				feaspath.classList.add( 'hidden' );
			}
		} );
	}
}

/***************************************************************************
 * Previous levels - called from createPathwayQuestions function
 ***************************************************************************/

function reviseQuestions( previousCrumb, decisionData ) {
	let code = 0;
	let level = 0;
	let qindex = 0;
	if ( previousCrumb ) {
		code = previousCrumb.dataset.code;
		qindex = previousCrumb.dataset.qindex;
		level = Number( previousCrumb.dataset.level );
	}
	level++;
	createSection( level, decisionData.sections );
	createPathwayQuestions( level, qindex, decisionData );
}

/***************************************************************************
 * Utility function to create a single element
 ***************************************************************************/

function createCustomElement(
	type,
	idclasses = [],
	attributes = [],
	innerText = ''
) {
	/* example :  archiveBtn = createCustomElement("button", { "id": "button1", "class": ["ctrlButton", "archiveBtnBtm"]}, {"data-dataid": dataId }); */
	const element = document.createElement( type );
	for ( const key in idclasses ) {
		if ( key == 'class' ) {
			/* classes cannot have spaces when added */
			const classArr = idclasses[ key ].filter( function ( entry ) {
				return /\S/.test( entry );
			} );
			element.classList.add.apply( element.classList, classArr ); // add all classes at once
		} else {
			element[ key ] = idclasses[ key ];
		}
	}
	for ( const key2 in attributes ) {
		element.setAttribute( key2, attributes[ key2 ] );
	}
	if ( innerText != '' ) {
		element.appendChild( document.createTextNode( innerText ) );
	}
	return element;
}
/***************************************************************************
 * Utility function to create a simple HTML hierarchy of elements
 ***************************************************************************/
function createCustomStructure(
	type,
	idclasses = [],
	attributes = [],
	children = []
) {
	/* example : createCustomStructure('section', {class: ['section1'] },{'data-something' : datael}, [['div', {class: ['child1'] }],['div', {class: ['child2'] }]]);*/
	const element = document.createElement( type );
	for ( const key in idclasses ) {
		if ( key == 'class' ) {
			/* classes cannot have spaces when added */

			const classArr = idclasses[ key ].filter( function ( entry ) {
				return /\S/.test( entry );
			} );
			element.classList.add.apply( element.classList, classArr ); // add all classes at once
		} else {
			element[ key ] = idclasses[ key ];
		}
	}
	for ( const key2 in attributes ) {
		element.setAttribute( key2, attributes[ key2 ] );
	}
	children.forEach( ( el ) => {
		const child = createCustomElement( ...el );
		element.appendChild( child );
	} );

	return element;
}
/***************************************************************************
 * Utility to remove all classes (typically before adding to one eleemnt)
 ***************************************************************************/
function removeClassFromAll( theparent, theselector, theclass ) {
	const allChildren = theparent.querySelectorAll( theselector );
	allChildren.forEach( ( thechild ) => {
		thechild.classList.remove( theclass );
	} );
}

/***************************************************************************
 * Utility function to remove child elements
 ***************************************************************************/
function empty( element ) {
	while ( element.firstElementChild ) {
		element.firstElementChild.remove();
	}
}

/***************************************************************************
 * Utility function next siblings
 ***************************************************************************/

function getNextSiblings( elem ) {
	const sibs = [];
	while ( ( elem = elem.nextSibling ) ) {
		if ( elem.nodeType === 3 ) {
			continue;
		} // text node
		sibs.push( elem );
	}
	return sibs;
}
/***************************************************************************
 * Utility function previous siblings
 ***************************************************************************/
function getPreviousSiblings( elem ) {
	const sibs = [];
	while ( ( elem = elem.previousSibling ) ) {
		if ( elem.nodeType === 3 ) {
			continue;
		} // text node
		sibs.push( elem );
	}
	return sibs;
}
/***************************************************************************
 * Utility function closeQuestions
 ***************************************************************************/
function closeQuestions() {
	const accordianQuestions = document.querySelectorAll( '.questionSection' );
	accordianQuestions.forEach( function ( elm ) {
		elm.classList.add( 'hidden' );
	} );
	const accordianSections = document.querySelectorAll( '.questionOptions' );
	accordianSections.forEach( function ( elt ) {
		elt.classList.add( 'inactive' );
	} );
}

function toggleParentActive( childEl ) {
	const parentContain = childEl.closest( '.questionOptions' );
	if ( parentContain ) {
		if ( parentContain.classList.contains( 'inactive' ) ) {
			parentContain.classList.remove( 'inactive' );
		} else {
			parentContain.classList.add( 'inactive' );
		}
	}
}

function makeParentActive( childEl ) {
	const parentContain = childEl.closest( '.questionOptions' );
	if ( parentContain ) {
		parentContain.classList.remove( 'inactive', 'hidden' );
	} else {
		//console.log( childEl );
	}
}

function splitLines( t ) {
	return t.split( /\r\n|\r|\n/ );
}

const convertSeconds = ( seconds ) => {
	const hours = Math.floor( seconds / 3600 );
	const minutes = Math.floor( ( seconds % 3600 ) / 60 );

	if ( hours > 0 ) {
		return `${ hours } hours : ${ minutes } minutes`;
	}
	return `${ minutes } minutes`;
};

const theCloseDialogs = document.querySelectorAll( '.nutritionDiaClose' );
theCloseDialogs.forEach( ( elclose ) => {
	elclose.addEventListener( 'click', function ( evt ) {
		evt.stopPropagation();
		const thisis = evt.target;
		const theClosestDialog = thisis.closest( 'dialog' );
		theClosestDialog.close();
	} );
} );

function replaceFoodPath( input ) {
	//console.log(input)
	const removeBeforeLastSlash = /^.*\//;
	const removeTrailingSlash = /\/$/;

	return input.replace( 'diet/', '' ).replace( '/', '' ).toLowerCase();
}

function runNutritionModal( dialogclass = 'theDialog' ) {
	// console.log(`.${dialogclass}Btn`)
	const theDialogBtns = document.querySelectorAll( `.${ dialogclass }Btn` );

	const theDialog = document.querySelector( `dialog.${ dialogclass }` );

	theDialogBtns.forEach( ( theDialogBtn ) => {
		theDialogBtn.addEventListener( 'click', function ( evt ) {
			if ( theDialog ) {
				theDialog.showModal();
				theDialog.addEventListener( 'click', clickOutsideToClose );
			}
		} );
	} );

	const closeDialogs = document.querySelectorAll( `.${ dialogclass }Close` );
	closeDialogs.forEach( ( el ) => {
		el.addEventListener( 'click', function ( evt ) {
			evt.stopPropagation();
			const thisis = evt.target;
			const theClosestDialog = thisis.closest( 'dialog' );
			theClosestDialog.close();
		} );
	} );
	function clickOutsideToClose( e ) {
		if ( e.target.id === `${ dialogclass }` ) {
			closeModalHandler();
		}
	}

	// this programmatically closes the dialog, and cleans up the event listener
	function closeModalHandler() {
		theDialog.removeEventListener( 'click', clickOutsideToClose );
		theDialog.close();
	}
}

function checkInfeasiblePathways( decisionData ) {
	/* console.log(
		'============================ Infeasible Questions decisionData.infeasibleQs ======================================='
	);
	console.log( decisionData );
	console.log(
		'============================ Infeasible Questions decisionData ======================================='
	);*/
	const resultsSection = document.querySelector( '.pathwaysCapturing' );
	if ( resultsSection ) {
		resultsSection.classList.remove( 'hidden' );

		const notCaptured = [];
		const okCaptured = [];
		decisionData.dietPaths.forEach( function ( aPath ) {
			const pathPart = aPath[ 0 ]; // This is the path such as 1A2A3A4C5A6B7B

			if ( aPath[ 2 ] === 'Fail' ) {
				let pathCaptured = false;
				pathCaptured = checkFailPathIsCaptured(
					decisionData,
					pathPart
				);
				if ( ! pathCaptured ) {
					notCaptured.push( pathPart );
				} else {
					okCaptured.push( pathPart );
				}
			}
		} );

		decisionData.foodPaths.forEach( function ( aPath ) {
			const pathPart = aPath[ 0 ]; // This is the path such as 1A2A3A4C5A6B7B
			if ( aPath[ 2 ] === 'Fail' ) {
				let pathCaptured = false;
				pathCaptured = checkFailPathIsCapturedFood(
					decisionData,
					pathPart
				);

				if ( ! pathCaptured ) {
					notCaptured.push( pathPart );
				} else {
					okCaptured.push( pathPart );
				}
			}
		} );
		/* console.log(
			'============================ Infeasible Fails Captured ======================================='
		);
		console.log( okCaptured );
		console.log(
			'============================ Infeasible Fails NOT Captured ======================================='
		);
		console.log( notCaptured );*/
	}
}

function checkFailPathIsCaptured( decisionData, path ) {
	//console.log( 'checking combinations' );

	/* 
     we loop through the current Fail paths, then see if there are any matches in the infeasible rules 
     */
	const resultsDiv = document.querySelector( '.pathwaysCheckNotCaptured' );
	const notCapturedDiv = document.querySelector(
		'.pathwaysCheckNotCaptured'
	);
	if ( resultsDiv && notCapturedDiv ) {
		const outputObj = new Object();
		let captured = false;
		decisionData.infeasibleQs.forEach( function ( infeasiblePattern ) {
			const infeasPartA = infeasiblePattern[ 0 ];
			const infeasPartB = infeasiblePattern[ 1 ];

			const infeasParts = infeasPartA + infeasPartB;
			const infLength = infeasPartA.length; // whether 2,4, 6
			const pathArray = path.match( /.{1,2}/g );

			outputObj.pathway = path;
			const infeasPartAIndx1 = Number( infeasPartA[ 0 ] ) - 1; // gets the index of the first question like 1A = 1
			const infeasPartBIndx = Number( infeasPartB[ 0 ] ) - 1; // gets the index of the first question like 3A = 3
			let pathParts;

			if ( infeasPartAIndx1 < 7 ) {
				switch ( infLength ) {
					case 2:
						pathParts =
							pathArray[ infeasPartAIndx1 ] +
							pathArray[ infeasPartBIndx ];
						if (
							pathParts === infeasParts &&
							infeasiblePattern[ 3 ] === '0'
						) {
							captured = true;
							outputObj.captureRule =
								infeasPartA + ' -> ' + infeasPartB;
							/* if ( path === '1F2A3B4D5B6B7A' ) {
								console.log(
									' ========================  CHECKING Here infeasPartA  ==========================='
								);
								console.log( infeasPartA );
								console.log(
									' ========================  CHECKING HERE  infeasPartB==========================='
								);
								console.log( infeasPartB );
								console.log(
									' ========================  CHECKING HERE  pathParts==========================='
								);
								console.log( pathParts );
								console.log(
									' ========================  CHECKING HERE  infeasiblePattern==========================='
								);
								console.log( infeasiblePattern );
							}*/
						}
						break;
					case 4:
						const infeasPartAIndx2 = Number( infeasPartA[ 2 ] ) - 1; // gets the index
						pathParts =
							pathArray[ infeasPartAIndx1 ] +
							pathArray[ infeasPartAIndx2 ] +
							pathArray[ infeasPartBIndx ];
						if (
							pathParts === infeasParts &&
							infeasiblePattern[ 3 ] === '0'
						) {
							captured = true;
							outputObj.captureRule =
								infeasPartA + ' -> ' + infeasPartB;
						}
						break;
					case 6:
						const infeasPartAIndx2a =
							Number( infeasPartA[ 2 ] ) - 1; // gets the index
						const infeasPartAIndx3 = Number( infeasPartA[ 4 ] ) - 1; // gets the index
						pathParts =
							pathArray[ infeasPartAIndx1 ] +
							pathArray[ infeasPartAIndx2a ] +
							pathArray[ infeasPartAIndx3 ] +
							pathArray[ infeasPartBIndx ];
						if (
							pathParts === infeasParts &&
							infeasiblePattern[ 3 ] === '0'
						) {
							captured = true;
							outputObj.captureRule =
								infeasPartA + ' -> ' + infeasPartB;
						}
						break;
					case 8:
						//console.log( 'four' );
						break;
					default:
						//console.log( `Sorry, we are out of options` );
				}
			} else {
				// console.log(infeasPartA)
			}
		} );

		if ( captured ) {
			//const capturedNote = createCustomElement('p', {},{},outputObj.pathway)
			//const capturedNote2 = createCustomElement('p', {},{},outputObj.captureRule)
			//capturedDiv.append(capturedNote, capturedNote2)
		}
		if ( ! captured ) {
			const capturedNote = createCustomElement(
				'p',
				{},
				{},
				outputObj.pathway
			);
			notCapturedDiv.append( capturedNote );
		}
		return captured;
	}

	//console.log( 'login to view infeasible pathways' );
}

function checkFailPathIsCapturedFood( decisionData, path ) {
	const resultsDiv = document.querySelector( '.pathwaysCheckNotCaptured' );
	const notCapturedDiv = document.querySelector(
		'.pathwaysCheckNotCaptured'
	);
	if ( resultsDiv && notCapturedDiv ) {
		const outputObj = new Object();
		let captured = false;
		decisionData.infeasibleQs.forEach( function ( infeasiblePattern ) {
			const infeasPartA = infeasiblePattern[ 0 ];
			const infeasPartB = infeasiblePattern[ 1 ];
			//const pathArray = path.match(/.{1,2}/g)
			outputObj.pathway = path;
			const infeasPartAIndx1 = Number( infeasPartA[ 0 ] ) - 1; // gets the index of the first question like 1A = 1
			if ( infeasPartAIndx1 > 7 ) {
				/* For now just one rule 9B, 10C1 */
				const pathQ9 = path.match( /9./g ); // Creates an array
				const pathQ10 = path.slice( -4 );
				if ( pathQ9[ 0 ] === infeasPartA && pathQ10 === infeasPartB ) {
					captured = true;
				}
			}
		} );

		if ( captured ) {
			//const capturedNote = createCustomElement('p', {},{},outputObj.pathway)
			//const capturedNote2 = createCustomElement('p', {},{},outputObj.captureRule)
			//notCapturedDiv.append(capturedNote, capturedNote2)
		}
		if ( ! captured ) {
			const capturedNote = createCustomElement(
				'p',
				{},
				{},
				outputObj.pathway
			);
			notCapturedDiv.append( capturedNote );
		}
		return captured;
	}

	//console.log( 'login to view infeasible pathways' );
}
